(function($) {
    'use strict';
})(jQuery);
